import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { SettingsProvider } from "./context/SettingsContext";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";

import SiteLayout from "./components/SiteLayout";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Checkout from "./pages/Checkout";
import Confirmation from "./pages/Confirmation";
import EventsCatering from "./pages/EventsCatering";
import OtherMenus from "./pages/OtherMenus";
import Contact from "./pages/Contact";
import Policy from "./pages/Policy";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import AlertsDashboard from "./pages/admin/AlertsDashboard";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminOrders from "./pages/admin/AdminOrders";
import MenuManager from "./pages/admin/MenuManager";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminEnquiries from "./pages/admin/AdminEnquiries";
import AdminUsers from "./pages/admin/AdminUsers";

function Public({ children }) {
  return <SiteLayout>{children}</SiteLayout>;
}

function App() {
  useEffect(() => {
    document.title = "Sapore Eats — Breakfast & Catering";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <CartProvider>
              <Toaster position="top-center" richColors />
              <Routes>
                <Route path="/" element={<Public><Home /></Public>} />
                <Route path="/menu" element={<Public><Menu /></Public>} />
                <Route path="/checkout" element={<Public><Checkout /></Public>} />
                <Route path="/confirmation/:reference" element={<Public><Confirmation /></Public>} />
                <Route path="/events" element={<Public><EventsCatering /></Public>} />
                <Route path="/other-menus" element={<Public><OtherMenus /></Public>} />
                <Route path="/contact" element={<Public><Contact /></Public>} />
                <Route path="/policy/:slug" element={<Public><Policy /></Public>} />

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="alerts" element={<AlertsDashboard />} />
                  <Route path="gallery" element={<AdminGallery />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="menu" element={<MenuManager />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="enquiries" element={<AdminEnquiries />} />
                  <Route path="users" element={<AdminUsers />} />
                </Route>
              </Routes>
            </CartProvider>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
